import axios from 'axios'

const RequestService = {
  async get (params = {}) {
    return axios.get('ro/purchase-order/requests', { params })
  },

  async histories (params = {}) {
    return axios.get('ro/reports/purchase-order/request-histories', { params })
  },

  async show (id) {
    return axios.get(`ro/purchase-order/requests/${id}`)
  },

  async post (params = {}) {
    return axios.post('ro/purchase-order/requests', params)
  },

  async put (params = { id: '' }) {
    return axios.put(`ro/purchase-order/requests/${params.id}`, params)
  },

  async delete (data = { id: '' }) {
    return axios.delete(`ro/purchase-order/requests/${data.id}`, { data })
  }
}

export default RequestService
